import React from 'react';
import { WhiteWhisperer } from './pages/WhiteWhisperer';
export function App() {
  return <WhiteWhisperer data-id="element-0" />;
}